module.exports = __webpack_public_path__ + "static/img/20003 (4).4e996ca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20003 (4).webp
// module id = Yr+k
// module chunks = 14